module.exports = __webpack_public_path__ + "media/images/vp/sample.profile-5f9e81bf12723d5b7278a971befecb1f.png";